module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bg_f5f6f9"
  }), _vm._v(" "), _c('search', {
    ref: "search",
    attrs: {
      "auto-fixed": false,
      "placeholder": "请输入关键字"
    },
    on: {
      "on-cancel": _vm.onCancel,
      "on-submit": _vm.onSearch
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  }), _vm._v(" "), _vm._l((_vm.channelList), function(item) {
    return _c('group', {
      key: item.name,
      attrs: {
        "title": item.name
      }
    }, _vm._l((item.data), function(ele) {
      return _c('cell', {
        key: ele.channelName,
        attrs: {
          "title": ele.channelName
        },
        nativeOn: {
          "click": function($event) {
            _vm.selectChannel(ele)
          }
        }
      })
    }))
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b667c45"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/channel/ChannelSelect.vue
// module id = 886
// module chunks = 1